export default "__VITE_ASSET__cfd2b120__"